<div class="modal-header">
  <h5 class="modal-title">Групповое перенаправление почты</h5>
  <button type="button" class="close" mat-dialog-close style="outline: none">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body property-window form form-horizontal">
  <div class="form-body">

    <!-- text -->
    <div class="form-group row">
      <div class="col-md-12">
        <p class="text-center">
          Для перенаправления обращений, вам необходимо заполнить фильтр. <br />
          Фильтр даты необходимо заполнять полностью.
        </p>
      </div>
    </div>

    <!-- vpo -->
    <div class="form-group row">
      <label class="col-md-3 label-control">Округ </label>
      <div class="col-md-4">
        <mat-form-field class="example-full-width">
          <input type="text" placeholder="..." aria-label="Number"
                 matInput [formControl]="vpoControl"
                 [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let option of vpoNames" [value]="option" (onSelectionChange)="selectVpo($event)">
              {{option.shortName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!-- date from -->
    <div class="form-group row">
      <label class="col-md-3 label-control">Дата с</label>
      <div class="col-md-4">
        <mat-form-field>
          <input [(ngModel)]="filter.dateFrom" matInput [matDatepicker]="picker1" placeholder="Выбрать дату" (click)="changeFilter()">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <!-- date to -->
    <div class="form-group row">
      <label class="col-md-3 label-control">Дата по</label>
      <div class="col-md-4">
        <mat-form-field>
          <input [(ngModel)]="filter.dateTo" matInput [matDatepicker]="picker2" placeholder="Выбрать дату" (click)="changeFilter()">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <!-- status -->
    <ng-container *ngIf="isForwardReady">
    <div class="form-group row">
      <label class="col-md-3 label-control">Статус</label>
      <div class="col-md-4">
          <p>
            отобрано обращений: <strong>{{selectedIds.length}}</strong>.
          </p>
          <p *ngIf="isForwarding" class="text-info">
            успешно отправлено: <strong>{{successIds.length}}</strong> из <strong>{{selectedIds.length}}</strong>, ошибок - {{errorIds.length}}.
          </p>
          <p *ngIf="errorIds.length" class="text-danger">
            ошибки:
            <span *ngFor="let e of errorIds" style="display: block">
              {{e}}
            </span>
          </p>
      </div>
    </div>
    </ng-container>

</div>
<div class="modal-footer" style="justify-content: center">
  <button class="btn btn-raised btn-warning mr-1" type="button" mat-dialog-close>
    <i class="ft-x"></i> Закрыть
  </button>
  <button class="btn btn-raised mr-1" type="button" style="background-color: #bebebe;" (click)="clearFilter()">
    <i class="ft-x"></i> Очистить фильтр
  </button>
  <button class="btn btn-raised btn-danger" type="button" type="button" [disabled]="!isForwardReady" (click)="forwardAll()">
    <i class="ft-check"></i> Переслать
  </button>
  <button class="btn btn-raised btn-primary" type="button" type="button" [disabled]="isForwarding" (click)="selectComplaints()">
    <i class="ft-check"></i> Отобрать
  </button>
</div>
